import { SiteDtoToEntity } from "src/app/features/Site/services/mappers/SiteDtoToEntity";
import type { SiteDto } from "src/app/features/Site/types/SiteDto";
import type { SiteEntity } from "src/app/features/Site/types/SiteEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const SiteTableDtoMapper = (input: Readonly<ResourcePageDto<SiteDto>>): ResourcePageEntity<SiteEntity> => {
    return {
        list: input.list ? input.list.map(SiteDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
